/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_History_FailedInputs */

const en_us2_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Couldn't load the history.`)
};

const pt_br2_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o histórico.`)
};

const es_419_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo cargar el historial.`)
};

const pt_pt2_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível carregar o histórico.`)
};

const fr_fr2_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger l'historique.`)
};

const de_de2_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Verlauf konnte nicht geladen werden.`)
};

const it_it2_exercise_sheet_history_failed = /** @type {(inputs: Exercise_Sheet_History_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile caricare lo storico.`)
};

/**
* | output |
* | --- |
* | "Couldn't load the history." |
*
* @param {Exercise_Sheet_History_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_history_failed = /** @type {((inputs?: Exercise_Sheet_History_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_History_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_history_failed(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_history_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_history_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_history_failed(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_history_failed(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_history_failed(inputs)
	return en_us2_exercise_sheet_history_failed(inputs)
});
export { exercise_sheet_history_failed as "exercise-sheet.history_failed" }